import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getBscGlobalState } from '../../../common/utils/bsc-global-state';
import { CategoryStorageType, PreferenceCategory } from '../../../types';
import { getPreferences } from '../../preferences-controls/get-preferences';
export var isThirdPartyAllowed = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(thirdParty) {
    var preferences, shouldDenyThirdParty, storageControlsData, _getBscGlobalState, loadCache, _storageControlsData, thirdPartyKeys, categories, thirdPartyCategoryNumber, numToCategoryMap, thirdPartyCategory, hasPreferencesForCategoryType;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getPreferences();
        case 2:
          preferences = _context.sent;
          if (preferences) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", Promise.resolve(false));
        case 5:
          shouldDenyThirdParty = false;
          _getBscGlobalState = getBscGlobalState(), loadCache = _getBscGlobalState.loadCache;
          _context.next = 9;
          return loadCache(CategoryStorageType.Cookies);
        case 9:
          storageControlsData = _context.sent;
          if (storageControlsData) {
            _storageControlsData = storageControlsData, thirdPartyKeys = _storageControlsData.thirdPartyKeys, categories = _storageControlsData.categories;
            thirdPartyCategoryNumber = thirdPartyKeys[thirdParty];
            numToCategoryMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, categories.STRICTLY_NECESSARY, PreferenceCategory.StrictlyNecessary), categories.FUNCTIONAL, PreferenceCategory.Functional), categories.ANALYTICS, PreferenceCategory.Analytics), categories.MARKETING, PreferenceCategory.Marketing), categories.UNKNOWN, PreferenceCategory.Unknown);
            thirdPartyCategory = thirdPartyCategoryNumber !== null ? numToCategoryMap[thirdPartyCategoryNumber] : null;
            hasPreferencesForCategoryType = false;
            if (!!thirdPartyCategory) {
              hasPreferencesForCategoryType = preferences[thirdPartyCategory];
            }
            shouldDenyThirdParty = hasPreferencesForCategoryType;
          }
          return _context.abrupt("return", Promise.resolve(shouldDenyThirdParty));
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function isThirdPartyAllowed(_x) {
    return _ref.apply(this, arguments);
  };
}();